<template>
	<div class="tab-pane fade " id="analytics-tab-pane" role="tabpanel" aria-labelledby="analytics-tab" tabindex="0">
		<div class="d-flex bd-highlight mt-4">
			<div class="p-2 flex-grow-1 bd-highlight">
				<h3>성과분석</h3>
			</div>
		</div>
		<div class="card rounded border-0 shadow overflow-hidden p-2">
			<div class="d-flex">
				<div class="p-2 w-25">
					<div class="rank-container ">
						<div class="input-group" id="search-channel">
							<span class="input-group-text bg-white rank-item-search" id="basic-addon1" @mouseup="searchChannel()">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
									<path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"></path>
								</svg>
							</span>
							<input
								autocomplete="off"
								id="search-channel-input"
								v-model="searchChannelInput"
								@keyup="searchChannel($event)"
								@focus="searchChannel()"
								type="text"
								class="rank-item-search bg-white form-control"
								placeholder="스토어 검색"
								aria-label="Input group example"
								aria-describedby="basic-addon1"
							/>
						</div>
					</div>
				</div>
				<div class="p-2 w-75">
					<div class="rank-container  ">
						<div class="input-group" id="search-product">
							<span class="input-group-text bg-white rank-item-search" id="basic-addon2" @mouseup="searchProductA()">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
									<path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"></path>
								</svg>
							</span>
							<input
								autocomplete="off"
								id="search-product-input"
								v-model="searchProductInput"
								@keyup="searchProductA($event)"
								@focus="searchProductA()"
								type="text"
								class="rank-item-search bg-white form-control"
								placeholder="상품 검색"
								aria-label="Input group example"
								aria-describedby="basic-addon2"
							/>
						</div>
					</div>
				</div>
				<div class="ms-auto p-2">
					<input type="text" class="form-control daterange" name="analytics-range" value="2023-01-01 ~ 2023-02-01" />
				</div>
			</div>
		</div>
		<div class="card rounded border-0 shadow overflow-hidden p-2 mt-4">
			<div class="d-flex justify-content-between ">
				<div class="p-2 w-20 ">
					<div id="select-chart1"></div>
				</div>

				<div class="p-2 w-20">
					<div id="select-chart2"></div>
				</div>
			</div>
			<div>
				<canvas id="analyticsChart"></canvas>
			</div>
		</div>

		<div class="container mt-4 px-1">
			<!-- <h6>TOAST UI</h6> -->
			<div id="grid"></div>
		</div>
		<div class="rank-container position-fixed font14 card border-dark" id="select-channels">
			<div class="list-group width100">
				<a v-on:click="selectChannel" v-for="channel in searchedChannels" :key="channel.channelNo" v-bind:value="channel.channelNo" :selected="false" class="list-group-item list-group-item-action cursor-pointer">
					{{ channel.channelName }}
				</a>
			</div>
		</div>
		<div class="rank-container position-fixed font14 card border-dark" id="select-products">
			<div class="list-group width100">
				<a v-on:click="selectProduct" v-for="product in searchedProducts" :key="product.productNo" v-bind:value="product.channelProductNo" :selected="false" class="list-group-item list-group-item-action cursor-pointer">
					{{ product.channelProductName }}
				</a>
			</div>
		</div>
	</div>
</template>
<style>
@import "../../../../css/tui-grid.css";
.cursor-pointer {
	cursor: pointer;
}
.w-20 {
	width: 20%;
}
.tui-select-box {
	text-align: center;
}
</style>
<script>
import moment from "moment";
import $ from "jquery";
import "daterangepicker";
import Grid from "tui-grid";
import SelectBox from "@toast-ui/select-box";
import Chart from "../../../../js/chart.min.js";
// import "../../../../js/chartjs-adapter-moment.js";
// import "../../../../js/chartjs-adapter-date-fns.bundle.min.js";
import axios from "axios";

export default {
	data() {
		return {
			searchedChannels: [],
			searchChannelInput: "",
			selectedChannelNo: "",

			searchedProducts: [],
			searchProductInput: "",
			selectedChannelProductNo: "",
			startDate: "",
			endDate: "",
			chartData: []
		};
	},
	components: {},
	created() {},
	beforeMount() {
		this.startDate = moment().subtract(7, "days");
		this.endDate = moment().subtract(1, "days");
	},
	mounted() {
		this.initAnalyticsType();
		this.initDatePickerAnalytics();
		this.initAnalyticsChart();
		this.initGrid();
	},
	methods: {
		initAnalyticsType: function() {
			const theme = {
				"common.border": "1px solid #e4e4e4",
				"common.color": "#353535",
				"common.background": "white",
				"common.width": "100px",
				"common.height": "30px",
				"common.font-size": "1rem",
				"common.z-index": "20",

				"common.disabled.background": "#f1f1f1",
				"common.disabled.color": "#d8d8d8",

				"dropdown.maxHeight": "300px",

				"itemGroup.items.paddingLeft": "15px",

				"itemGroup.label.color": "black",

				"item.selected.background": "white",
				"item.selected.color": "black",

				"item.highlighted.background": "#355dff",
				"item.highlighted.color": "white"
			};

			let theme2 = {
				"common.border": "1px solid #e4e4e4",
				"common.color": "#353535",
				"common.background": "white",
				// "common.width": "50%",
				"common.height": "40px",
				"common.font-size": "1rem",
				"common.z-index": "20",

				"common.disabled.background": "#f1f1f1",
				"common.disabled.color": "#d8d8d8",

				"dropdown.maxHeight": "300px",

				"itemGroup.items.paddingLeft": "15px",

				"itemGroup.label.color": "black",

				"item.selected.background": "white",
				"item.selected.color": "black",

				"item.highlighted.background": "#355dff",
				"item.highlighted.color": "white"
			};

			let analyticChartOptions = new Array(
				{ label: "노출수", value: "impression" },
				{ label: "클릭수", value: "click" },
				{ label: "총비용", value: "cost" },
				{ label: "전환수", value: "conversionCount" },
				{ label: "전환매출액", value: "salesByConversion" },
				{ label: "평균노출순위", value: "sumOfAdRank" }
			);

			const chart1 = document.getElementById("select-chart1");
			const selectBox1 = new SelectBox(chart1, {
				data: analyticChartOptions,
				theme: theme2
			});

			const chart2 = document.getElementById("select-chart2");
			const selectBox2 = new SelectBox(chart2, {
				data: analyticChartOptions,
				theme: theme2
			});

			let selectBoxIcons = document.getElementsByClassName("tui-select-box-icon");
			for (var i = 0; i < selectBoxIcons.length; i++) {
				selectBoxIcons[i].innerText = "";
			}

			selectBox1.on(
				"change",
				function(ev) {
					console.log(ev);
					console.log(this.$parent.channels);
					this.selectedChannelNo = ev.curr.value;
					// this.updateDashBoard();
				}.bind(this)
			);
			// this.updateDashBoard();
		},
		initDatePickerAnalytics: function() {
			let yesterday = moment()
				.subtract(1, "days")
				.toDate();
			let last7day = moment()
				.subtract(7, "days")
				.toDate();
			let last30day = moment()
				.subtract(30, "days")
				.toDate();
			let last365day = moment()
				.subtract(365, "days")
				.toDate();

			let lastMonthStart = moment()
				.subtract(1, "month")
				.startOf("month")
				.toDate();
			let lastMonthEnd = moment()
				.subtract(1, "month")
				.endOf("month")
				.toDate();
			let lastYearStart = moment()
				.subtract(1, "year")
				.startOf("year")
				.toDate();
			let lastYearEnd = moment()
				.subtract(1, "year")
				.endOf("year")
				.toDate();

			$('input[name="analytics-range"]').daterangepicker(
				{
					opens: "left",
					alwaysShowCalendars: true,
					startDate: last7day,
					endDate: yesterday,
					maxDate: yesterday,
					cancelClass: " btn btn-outline-primary ",
					locale: {
						// direction: 'l', //direction of text
						format: "YYYY-MM-DD",
						separator: " ~ ", //separator between the two ranges
						applyLabel: "확인",
						cancelLabel: "취소",
						weekLabel: "주",
						customRangeLabel: "직접입력",
						alwaysShowCalendars: true,

						monthNames: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
						daysOfWeek: ["일", "월", "화", "수", "목", "금", "토"],
						firstDay: 0
					},

					ranges: {
						//default value for ranges object (if you set this to false ranges will no be rendered)
						어제: [yesterday, yesterday],
						"최근 7일": [last7day, yesterday],
						"최근 30일": [last30day, yesterday],
						"최근 365일": [last365day, yesterday],
						"지난 1달": [lastMonthStart, lastMonthEnd],
						"지난 1년": [lastYearStart, lastYearEnd]
					}
				},
				function(start, end, label) {
					console.log(start);
					console.log(end);
					console.log(label);
					this.startDate = start;
					this.endDate = end;
					// this.updateDashBoard();
				}.bind(this)
			);
		},
		initAnalyticsChart() {
			const ctx = document.getElementById("analyticsChart");
			const labels = ["January", "February", "March", "April", "May", "June"];
			const dataset1 = [100, 150, 200, 250, 310, 330];
			const dataset2 = [100, 200, 150, 250, 300, 350];

			const data = {
				labels: labels,
				datasets: [
					{
						label: "Dataset 1",
						data: dataset1,
						borderColor: "rgb(255, 99, 132)",
						backgroundColor: "rgb(255, 159, 64)",
						yAxisID: "y"
					},
					{
						label: "Dataset 2",
						data: dataset2,
						borderColor: "rgb(54, 162, 235)",
						backgroundColor: "rgb(75, 192, 192)",
						yAxisID: "y2"
					}
				]
			};

			const options = {
				responsive: true,
				interaction: {
					mode: "index",
					intersect: false
				},
				stacked: false,
				plugins: {
					legend: {
						position: "bottom"
					},
					title: {
						display: false,
						text: "Chart.js Line Chart - Multi Axis"
					}
				},
				scales: {
					x: {
						display: true,
						title: {
							display: true,
							text: "X-Axis Label"
						}
					},
					y: {
						beginAtZero: true,
						type: "linear",
						display: true,
						position: "left",
						id: "y"
					},
					y2: {
						beginAtZero: true,
						type: "linear",
						display: true,
						position: "right",
						id: "y2",

						// grid line settings
						grid: {
							drawOnChartArea: false // only want the grid lines for one axis to show up
						}
					}
				}
			};

			const config = {
				type: "line",
				data,
				options
			};
			this.chart = new Chart(ctx, config);
		},
		initGrid: function() {
			new Grid({
				// rowHeight: 20,
				// minRowHeight: 10,
				rowHeaders: ["checkbox"],
				bodyHeight: 400,
				pageOptions: {
					useClient: true,
					type: "scroll",
					perPage: 50
				},
				el: document.getElementById("grid"),
				data: [
					{
						name: "아머스 모래주머니",
						sales: "10,000",
						total: "20,000",
						release: "A2016.03.26",
						genre: "APop"
					},
					{
						name: "Beautiful Lies",
						sales: "Birdy",
						total: "Btotal",
						release: "B2016.03.26",
						genre: "BPop"
					},
					{
						name: "CBeautiful Lies",
						sales: "CBirdy",
						total: "Ctotal",
						release: "C2016.03.26",
						genre: "CPop"
					},
					{
						name: "DBeautiful Lies",
						sales: "DBirdy",
						total: "Dtotal",
						release: "D2016.03.26",
						genre: "DPop"
					},
					{
						name: "EBeautiful Lies",
						sales: "EBirdy",
						total: "Atotal",
						release: "A2016.03.26",
						genre: "APop"
					},
					{
						name: "Feautiful Lies",
						sales: "Firdy",
						total: "Btotal",
						release: "B2016.03.26",
						genre: "BPop"
					},
					{
						name: "GBeautiful Lies",
						sales: "CBirdy",
						total: "Ctotal",
						release: "C2016.03.26",
						genre: "CPop"
					},
					{
						name: "HBeautiful Lies",
						sales: "DBirdy",
						total: "Dtotal",
						release: "D2016.03.26",
						genre: "DPop"
					},
					{
						name: "IBeautiful Lies",
						sales: "ABirdy",
						total: "Atotal",
						release: "A2016.03.26",
						genre: "APop"
					},
					{
						name: "Jeautiful Lies",
						sales: "Birdy",
						total: "Btotal",
						release: "B2016.03.26",
						genre: "BPop"
					},
					{
						name: "KBeautiful Lies",
						sales: "CBirdy",
						total: "Ctotal",
						release: "C2016.03.26",
						genre: "CPop"
					},
					{
						name: "LBeautiful Lies",
						sales: "DBirdy",
						total: "Dtotal",
						release: "D2016.03.26",
						genre: "DPop"
					},
					{
						name: "MBeautiful Lies",
						sales: "ABirdy",
						total: "Atotal",
						release: "A2016.03.26",
						genre: "APop"
					},
					{
						name: "Neautiful Lies",
						sales: "Birdy",
						total: "Btotal",
						release: "B2016.03.26",
						genre: "BPop"
					},
					{
						name: "OBeautiful Lies",
						sales: "CBirdy",
						total: "Ctotal",
						release: "C2016.03.26",
						genre: "CPop"
					},
					{
						name: "PBeautiful Lies",
						sales: "DBirdy",
						total: "Dtotal",
						release: "D2016.03.26",
						genre: "DPop"
					}
				],
				columns: [
					{
						header: "상품명",
						name: "name",
						sortable: true,
						sortingType: "asc"
					},
					{
						header: "광고비",
						name: "sales",
						sortable: true
					},
					{
						header: "ACos",
						name: "acos",
						sortable: true
					},
					{
						header: "ROAS",
						name: "roas",
						sortable: true
					},
					{
						header: "노출수",
						name: "impression",
						sortable: true
					},
					{
						header: "클릭수",
						name: "clicks",
						sortable: true
					},
					{
						header: "CTR",
						name: "ctr",
						sortable: true,
						sortingType: "asc"
					},
					{
						header: "CPC",
						name: "cpc",
						sortable: true
					},
					{
						header: "CVR",
						name: "CVR",
						sortable: true
					},
					{
						header: "PPC Order",
						name: "ppcorder",
						sortable: true
					}
				],
				columnOptions: {
					frozenCount: 1, // 3개의 컬럼을 고정하고
					frozenBorderWidth: 2 // 고정 컬럼의 경계선 너비를 2px로 한다.
				}
			});
			// instance.resetData(grid); // Call API of instance's public method
			// grid.refreshLayout();
			Grid.applyTheme("defalut", {
				cell: {
					header: {
						background: "#fff"
					},
					normal: {
						background: "#fefee6",
						showVerticalBorder: false,
						showHorizontalBorder: true
					}
				}
			});

			// Grid.applyTheme("striped");
		},
		searchChannel: function(event) {
			this.searchedChannels = [];
			if (!this.$parent.channels) {
				return;
			}
			for (let channel of this.$parent.channels) {
				if (event) {
					let searchItem = event.target.value.trim();
					let channelName = channel.channelName;
					if (channelName.toLowerCase().includes(searchItem.toLowerCase()) || searchItem.trim() == "") {
						this.searchedChannels.push(channel);
					}
				} else {
					this.searchedChannels.push(channel);
				}
				if (this.searchedChannels.length > 8) {
					this.scms = true;
					break;
				}
			}
			if (this.searchedChannels.length > 0) {
				this.positioning("channel");
			}
		},
		selectChannel: function(event) {
			document.getElementById("select-channels").style.display = "none";
			document.getElementById("select-products").style.display = "none";

			this.selectedChannelNo = "";
			if (event) {
				this.selectedChannelNo = event.target.getAttribute("value");
				this.searchChannelInput = event.target.innerText.trim();
			}

			this.searchedProducts = [];

			if (this.selectedChannelNo != "") {
				this.searchProductInput = "";
				this.getProducts();
			}

			this.getAnalyticsData();
			// 차트 + 표 그리기
		},
		async getProducts() {
			const params = { channelNo: this.selectedChannelNo };
			const response = await axios.get("/commerce/getProducts", { params });
			if (response.status == 200 && response.data.products) {
				this.products = response.data.products;
			}
		},
		searchProductA: function(event) {
			document.getElementById("select-channels").style.display = "none";
			document.getElementById("select-products").style.display = "none";
			if (!this.products) {
				return;
			}

			this.searchedProducts = [];
			for (let product of this.products) {
				if (event) {
					let searchItem = event.target.value.trim();
					let channelProductName = product.channelProductName;
					if (channelProductName.toLowerCase().includes(searchItem.toLowerCase()) || searchItem.trim() == "") {
						this.searchedProducts.push(product);
					}
				} else {
					this.searchedProducts.push(product);
				}
				if (this.searchedProducts.length > 8) {
					break;
				}
			}
			if (this.searchedProducts.length > 0) {
				this.positioning("product");
			}
		},
		selectProduct(event) {
			document.getElementById("select-products").style.display = "none";
			if (event) {
				this.selectedChannelProductNo = event.target.getAttribute("value");
				this.searchProductInput = event.target.innerText.trim();
			}
		},
		positioning(pc) {
			let sc = document.getElementById("search-" + pc);
			let top = window.scrollY + sc.getBoundingClientRect().top;
			let left = window.scrollX + sc.getBoundingClientRect().left;

			let sk = document.getElementById("search-" + pc + "-input");
			let st = document.getElementById("select-" + pc + "s");

			st.style.top = top + 40 + "px";
			st.style.left = left + 41 + "px";
			st.style.width = sk.offsetWidth + "px";
			st.style.padding = "0px";
			st.style.display = "block";
		},
		async getAnalyticsData() {
			let startDateStr = this.startDate.format("YYYYMMDD");
			let endDateStr = this.endDate.format("YYYYMMDD");
			const params = { channelNo: this.selectedChannelNo, productId: this.selectedChannelProductNo, startDate: startDateStr, endDate: endDateStr };
			const response = await axios.get("/ad/analytics", { params });
			if (response.status == 200 && response.data.report) {
				console.log(response.data.report);
				this.chartData = response.data.report;
				this.drawChart();
			}
		},
		drawChart() {
			while (this.chart.data.labels.length > 0) {
				this.chart.data.labels.pop();
			}
			while (this.chart.data.datasets.length > 0) {
				this.chart.data.datasets.pop();
			}

			if (this.endDate.month() - this.startDate.month() < 3) {
				this.chart.options.scales.x.time.unit = "day";
				this.chart.options.scales.x.time.displayFormats.day = "yyyy-MM-dd";
			} else {
				this.chart.options.scales.x.time.unit = "month";
				this.chart.options.scales.x.time.displayFormats.month = "yyyy-MM-dd";
			}

			let startDateStr = this.startDate.format("YYYY-MM-DD");
			let endDateStr = this.endDate.format("YYYY-MM-DD");

			this.chart.options.scales.x.time.suggestedMin = startDateStr;
			this.chart.options.scales.x.time.suggestedMax = endDateStr;

			const dataset = {
				label: keyword,
				data: selectedTypeData,
				borderColor: "#" + Math.round(Math.random() * 0xffffff).toString(16)
			};
			this.chart.data.datasets.push(dataset);
			this.chart.update();
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/main/naverad/Analytics.vue